module.exports = __webpack_public_path__ + "28fdd9b8091dc170ba414b656f2bac8c.woff";